<nz-layout class="app-layout">
  <nz-header class="app-layout-header">
    <div class="sidebar-logo">
      <a href="/" target="_blank">
        <img nz-image nzSrc="/assets/images/nfl_logo.png" nzDisablePreview="true" alt="NFL LOGO" />
      </a>
      <span class="title">{{ appName }}</span>
    </div>
    <span *ngIf="orgId !== 'nfl'" class="divider"></span>
    <img *ngIf="orgId !== 'nfl'" [src]="headerLogoURL" [alt]="orgId" />
    <app-header></app-header>
  </nz-header>

  <nz-layout class="app-body">
    <nz-sider
      class="app-sidebar"
      [nzWidth]="sideBarWidth"
      nzCollapsible
      nzBreakpoint="md"
      [(nzCollapsed)]="themeService.isSidebarCollapsed"
      [nzTrigger]="null"
    >
      <app-sidebar></app-sidebar>
    </nz-sider>

    <nz-content>
      <div class="main-content" [class.no-top-left-padding]="isMarketOverview"><router-outlet></router-outlet></div>
    </nz-content>
  </nz-layout>
</nz-layout>
